// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__YkIA+","preferencesContainer":"Profile_preferencesContainer__2PCQu"};